import { Controller } from "@hotwired/stimulus"
import constants from "../globals/constants"

export default class extends Controller {
  static targets = ["operatingMode", "batteryGridControls"]
  static values = { capabilityType: String }

  toggleConditionalFields() {
    if (this.capabilityTypeValue !== constants.THING_TYPE.BATTERY) return
    if (!this.hasBatteryGridControlsTarget) return

    const showGrid = this.operatingModeTarget.value === 'GRIID_CONTROLLED'
    this.batteryGridControlsTarget.classList.toggle('d-none', !showGrid)
  }
}
